/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { toMessages } from 'config/messages';

export default toMessages('BankAccount.Validation', {
  BankAccountNameTaken: 'Account name already in use',
  InvalidAccount: 'This account is not valid for making a payment.',
  SelectAccount: 'Please select a payment account.'
});
